import validate from "/build/incl/node_modules/.pnpm/nuxt@3.21.11_@types+node@24.19.2_@vue+compiler-sfc@3.5.44_esbuild@0.25.1_eslint@8.55.0__9b8d368a841e06098d7f405f471e9499/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/build/incl/node_modules/.pnpm/nuxt@3.21.11_@types+node@24.19.2_@vue+compiler-sfc@3.5.44_esbuild@0.25.1_eslint@8.55.0__9b8d368a841e06098d7f405f471e9499/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  archive: () => import("/build/incl/middleware/archive.ts"),
  auth: () => import("/build/incl/middleware/auth.ts"),
  "open-feature": () => import("/build/incl/middleware/openFeature.ts"),
  role: () => import("/build/incl/middleware/role.ts")
}